<template>
  <div class="content pure-content">
    <div class="action-bar">
      <div class="action-left">
        <el-input v-model="kw" placeholder="请输入账户名称" size="small" prefix-icon="el-icon-search" @keyup.enter.native="search"></el-input>
        <el-select v-model="type" placeholder="操作类型" size="small" clearable>
          <el-option v-for="type in actionTypes" :key="type.key" :value="type.key" :label="type.name"></el-option>
        </el-select>
      </div>
      <div class="action-right">
        <el-button size="small" @click="downloadReport">报表下载</el-button>
        <el-date-picker v-model="date" type="daterange" size="small" :picker-options="pickerOptions" :default-value="defaultDate" value-format="yyyy/MM/dd"></el-date-picker>
      </div>
    </div>
    <div class="list-body">
      <el-table :data="list" border :height="listBodyHeight" size="small" v-loading="loading">
        <el-table-column label="申请单号" prop="recordId" min-width="80"></el-table-column>
        <el-table-column label="到账时间" prop="successTimeFormat" min-width="150"></el-table-column>
        <el-table-column label="申请时间" prop="applyTimeFormat" min-width="150"></el-table-column>
        <el-table-column label="操作类型" prop="typeFormat" min-width="100"></el-table-column>
        <el-table-column label="账户ID" v-if="isShowAccountId" prop="accountId" min-width="100"></el-table-column>
        <el-table-column label="账户名称" prop="accountName" min-width="200"></el-table-column>
        <el-table-column v-if="auth.recharge" label="打款账号" prop="bankAccount" min-width="100"></el-table-column>
        <el-table-column label="现金金额(元)" prop="amount" min-width="130"></el-table-column>
        <el-table-column label="虚拟金金额" prop="virtualAmount" min-width="100"></el-table-column>
        <el-table-column label="状态" prop="statusFormat" min-width="180">
          <template slot-scope="scope">
            <span :class="{'main-text': [STATUS.Checking, STATUS.Recharge_Fail].includes(scope.row.status)}">
              {{scope.row.statusFormat}}
              <el-tooltip placement="bottom" effect="light" v-if="scope.row.status == STATUS.Checking && scope.row.type !== 8">
                <p slot="content">如果本条记录长时间处于 [充值中] 状态，请您<br>尝试按照正确的银行账号与打款金额重新提交<br>充值申请，或<a href="http://e.mi.com/v2/dist/help.html#28" target="_blank" rel="opener">点击此处</a>查看更多可能的原因。</p>
                <i class="el-icon-question"></i>
              </el-tooltip>
              
            </span>
            <el-button type="text" size="small" v-if="scope.row.status == STATUS.Recharge_Fail && scope.row.type !== 8" @click="reCharge(scope.row.recordId)">重新提交</el-button>
            <el-button type="text" size="small" v-if="[STATUS.Checking, STATUS.Recharge_Fail].includes(scope.row.status) && scope.row.type !== 8" @click="deleteRecord(scope.row.recordId)">删除</el-button>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="description" min-width="140"></el-table-column>
      </el-table>
    </div>
    <div class="page-box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.currentPage"
        :page-sizes="page.pageSizes"
        :page-size="page.pageSize"
        :background="true"
        layout="total, prev, pager, next, jumper, sizes"
        :total="page.total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
  import {rechargeActionTypes, getRechargeList, deleteChargeRecord, doRecharge} from '../utils/api.js';
  import mixins from '../utils/mixins.js';
  const STATUS = {
    Checking: 1, //充值中
    Repealed: 2, //已撤销
    Recharge_Ok: 3, //成功
    Recharge_Fail: 4, //充值失败
    Precharge: 5, //预充值
    Precharge_Repay: 6, //预充值还款
    Wrong: 7 //充值异常
  }
  export default {
    name: 'recharge-list',
    mixins: [mixins],
    props: {
      auth: Object
    },
    data() {
      return {
        STATUS,
        kw: '',
        type: '',
        actionTypes: []
      }
    },
    computed: {
      isShowAccountId() {
        return this.$route.params && ['core', 'agent'].includes(this.$route.params.type);
      }
    },
    watch: {
      type() {
        this.page.currentPage = 1;
        this.getDataList();
      }
    },
    created() {
      this.getActionTypes();
      this.getDataList();
    },
    methods: {
      downloadReport() {
        let params = {
          kw: this.kw.trim(),
          type: this.type,
          sdate: this.date && this.date.length ? this.date[0] : '',
          edate: this.date && this.date.length ? this.date[1] : ''
        }
        Object.assign(params, window.GLOBAL.userInfo);
        let search = Object.keys(params).map(key => {
          return `${encodeURIComponent(key)}=${params[key]}`;
        }).join('&');
        window.open('/v2/finance/recharge/records/export?' + search);
      },
      search() {
        this.page.currentPage = 1;
        this.getDataList();
      },
      async deleteRecord(recordId) {
        let result = await deleteChargeRecord({recordId});
        if (result && result.success) {
          this.getDataList();
        }
      },
      async reCharge(recordId) {
        let result = await doRecharge({recordId});
        if (result && result.success) {
          this.getDataList();
        }
      },
      async getActionTypes() {
        let result = await rechargeActionTypes();
        if (result && result.length) {
          this.actionTypes = result;
        }
      },
      async getDataList() {
        let params = {
          kw: this.kw.trim(),
          type: this.type,
          sdate: this.date && this.date.length ? this.date[0] : '',
          edate: this.date && this.date.length ? this.date[1] : '',
          page: this.page.currentPage,
          pagesize: this.page.pageSize
        }
        this.loading = true;
        let result = await getRechargeList(params);
        if (result) {
          this.list = result.list || [];
          this.page.total = result.conf.totalnum;
        }
        this.loading = false;
      }
    }
  };
</script>